import * as React from "react";
import { useCallback } from "react";
import { Button } from "components/bootstrap";
import useInputsStates from "hooks/useInputsStates";
import useInputsList from "hooks/useInputs";
import { useQueryParams, ArrayParam, NumberParam, StringParam } from "routing/QueryParams";
import { RUNTIME_STATUS_FILTER, FAILED_MESSAGE, SETUP_MESSAGE, STOPPED_MESSAGE } from "./Constants";
import NotificationBanner from "./NotificationBanner";
const INPUT_STATES = {
  FAILED: "FAILED",
  FAILING: "FAILING",
  SETUP: "SETUP"
};
const hasInputInState = (inputStates, targetStates) => {
  const statesToCheck = Array.isArray(targetStates) ? targetStates : [targetStates];
  for (const nodeStates of Object.values(inputStates)) {
    for (const inputState of Object.values(nodeStates)) {
      if (statesToCheck.includes(inputState.state)) {
        return true;
      }
    }
  }
  return false;
};
const getNotificationItems = (inputs, inputStates, isLoading) => {
  if (isLoading || !inputs || !inputStates) return [];
  const result = [];
  if (hasInputInState(inputStates, [INPUT_STATES.FAILED, INPUT_STATES.FAILING])) {
    result.push({ severity: "danger", message: FAILED_MESSAGE });
  }
  if (hasInputInState(inputStates, INPUT_STATES.SETUP)) {
    result.push({ severity: "warning", message: SETUP_MESSAGE });
  }
  if (inputs.some((input) => !inputStates[input.id])) {
    result.push({ severity: "warning", message: STOPPED_MESSAGE });
  }
  return result;
};
const InputsNotifications = () => {
  const { data: inputStates, isLoading } = useInputsStates();
  const { data: inputs } = useInputsList();
  const [, setQueryParams] = useQueryParams({
    filters: ArrayParam,
    page: NumberParam,
    slice: StringParam,
    sliceCol: StringParam
  });
  const applyRuntimeStatusFilter = useCallback(
    (status) => {
      setQueryParams({
        filters: [`${RUNTIME_STATUS_FILTER}=${status}`],
        page: 1,
        slice: void 0,
        sliceCol: void 0
      });
    },
    [setQueryParams]
  );
  const items = getNotificationItems(inputs, inputStates, isLoading).map((item) => {
    if (item.message === FAILED_MESSAGE) {
      return {
        ...item,
        id: "failed",
        message: /* @__PURE__ */ React.createElement(React.Fragment, null, FAILED_MESSAGE, " ", /* @__PURE__ */ React.createElement(Button, { bsStyle: "link", onClick: () => applyRuntimeStatusFilter("FAILED") }, "Show failed inputs"), ".")
      };
    }
    if (item.message === SETUP_MESSAGE) {
      return {
        ...item,
        id: "setup",
        message: /* @__PURE__ */ React.createElement(React.Fragment, null, SETUP_MESSAGE, " ", /* @__PURE__ */ React.createElement(Button, { bsStyle: "link", onClick: () => applyRuntimeStatusFilter("SETUP") }, "Show inputs in setup mode"), ".")
      };
    }
    if (item.message === STOPPED_MESSAGE) {
      return {
        ...item,
        id: "stopped",
        message: /* @__PURE__ */ React.createElement(React.Fragment, null, STOPPED_MESSAGE, " ", /* @__PURE__ */ React.createElement(Button, { bsStyle: "link", onClick: () => applyRuntimeStatusFilter("NOT_RUNNING") }, "Show stopped inputs"), ".")
      };
    }
    return item;
  });
  return /* @__PURE__ */ React.createElement(NotificationBanner, { title: "Warning", items });
};
export default InputsNotifications;
